var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-followBox"},[(_vm.toShow)?_c('div',{staticClass:"followBox-wrap"},[_c('img',{staticClass:"follow_img",attrs:{"src":require("../../assets/follow.png")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }